<template src="@/templates/StaticWelcomeKind.html"></template>

<script>
	export default {
		name: "StaticWelcomeKind",
		// props: ['identifier'],
		created () {
			// this.createComponent();
		},
		methods: {
			// createComponent() {
			// 	console.log(this.identifier);
			// }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/StaticWelcomeKind.vue